var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    fill: "none",
    viewBox: "0 0 14 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Heart",
    fill: "currentColor",
    d: "m1.442 7.476 4.107 4.328a2 2 0 0 0 2.902 0l4.107-4.328c1.478-1.558 1.478-4.083 0-5.641a3.65 3.65 0 0 0-5.352 0 .284.284 0 0 1-.412 0 3.65 3.65 0 0 0-5.352 0c-1.478 1.558-1.478 4.083 0 5.64"
  })));
};
export default SvgLike;